import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  Menu,
  X,
  ArrowRight,
} from "lucide-react";

export default function Navbar() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const links = [
    { name: "Home", path: "/home" },
    { name: "Gallery", path: "/gallery" },
    { name: "Reviews & Contact", path: "/reviews" },
  ];

  return (
    <nav
      className="
      fixed top-0 left-0 right-0
      z-50
      backdrop-blur-xl
      bg-black/30
      border-b border-white/10
      "
    >
      <div className="max-w-7xl mx-auto px-6 h-20 flex items-center justify-between">

        {/* Logo */}

        <Link
          to="/home"
          className="flex items-center gap-4"
        >
          <div
            className="
            w-12 h-12
            rounded-full
            border border-[#C9A66B]
            flex items-center justify-center
            text-[#C9A66B]
            font-bold
            text-xl
            "
          >
            <img src="/logo-Photoroom.png" alt="Logo" />
          </div>

          <div>
            <h2
              className="text-white font-semibold"
              style={{
                fontFamily: "'Fraunces', serif",
              }}
            >
              Ebenezer
            </h2>

            <p className="text-xs tracking-[0.25em] text-[#C9A66B] uppercase">
              Serviced Apartments
            </p>
          </div>
        </Link>

        {/* Desktop */}

        <div className="hidden lg:flex items-center gap-10">

          {links.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`relative transition
              ${
                location.pathname === link.path
                  ? "text-[#C9A66B]"
                  : "text-white/80 hover:text-[#C9A66B]"
              }`}
            >
              {link.name}

              {location.pathname === link.path && (
                <span
                  className="
                  absolute
                  left-0
                  -bottom-2
                  h-[2px]
                  w-full
                  bg-[#C9A66B]
                  "
                />
              )}
            </Link>
          ))}

          <a
            href="https://wa.me/"
            className="
            flex items-center gap-2
            px-5 py-3
            bg-[#C9A66B]
            text-black
            rounded-full
            font-medium
            hover:opacity-90
            transition
            "
          >
            Book Stay

            <ArrowRight size={18} />
          </a>
        </div>

        {/* Mobile */}

        <button
          onClick={() =>
            setMobileMenuOpen(!mobileMenuOpen)
          }
          className="lg:hidden text-white"
        >
          {mobileMenuOpen ? (
            <X />
          ) : (
            <Menu />
          )}
        </button>
      </div>

      {/* Mobile Drawer */}

      {mobileMenuOpen && (
        <div
          className="
          lg:hidden
          bg-[#1F1B18]
          border-t border-white/10
          "
        >
          <div className="flex flex-col p-6 gap-5">

            {links.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() =>
                  setMobileMenuOpen(false)
                }
                className="text-white/80 hover:text-[#C9A66B]"
              >
                {link.name}
              </Link>
            ))}

            <a
              href="https://wa.me/"
              className="
              mt-3
              text-center
              bg-[#C9A66B]
              text-black
              py-3
              rounded-full
              "
            >
              Book Your Stay
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}